import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { AvailableCamera, EditModeContextWithOriginalState, LocationImpl } from '../../../types';

type CellParams = ICellRendererParams & {
  isEditing: () => boolean;
  isSaving: () => boolean;
  editContext: () => EditModeContextWithOriginalState;
  availableCameras: (location: LocationImpl) => AvailableCamera[];
};

@Component({
  selector: 'app-cell-subscriptions-cameras',
  imports: [UiModule, NgSelectModule, FormsModule],
  templateUrl: './cell-subscriptions-cameras.component.html',
  styleUrl: './cell-subscriptions-cameras.component.scss',
})
export class CellSubscriptionsCamerasComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
